import request from '@/utils/request'

// 招标公告展示
export function getSectionByIdWithAuth(id) {
  return request({
    url: '/system/section/getSectionByIdWithAuth/' + id,
    method: 'get'
  })
}
// 关注
export function follow(data) {
  return request({
    url: '/follow' ,
    method: 'post',
    data:data
  })
}
// 取消关注
export function DelFollow(id) {
  return request({
    url: '/follow/' +id,
    method: 'delete',
  })
}
// 报名
export function quotationSignup(data) {
  return request({
    url: '/quotation/signup' ,
    method: 'post',
    data:data
  })
}
// 报名详情
export function signupGetWithAuth(id) {
  return request({
    url: '/quotation/signup/getWithAuth/'+id ,
    method: 'get',
  })
}
// 提交资质
export function signupSubmitQualification(data) {
  return request({
    url: '/quotation/signup/submitQualification' ,
    method: 'post',
    data:data
  })
}
// 提交缴费信息
export function signupSubmitPayment(data) {
  return request({
    url: '/quotation/signup/submitPayment' ,
    method: 'post',
    data:data
  })
}
// 供应商提交标书
export function signupSubmitSupplierBidFile(data) {
  return request({
    url: '/quotation/signup/submitSupplierBidFile' ,
    method: 'post',
    data:data
  })
}
// 撤回标书
export function signupCancelSupplierBidFile(data) {
  return request({
    url: '/quotation/signup/cancelSupplierBidFile' ,
    method: 'post',
    data:data
  })
}
// 弃标
export function signupUpdateSupplierBidStatus(data) {
  return request({
    url: '/quotation/signup/updateSupplierBidStatus' ,
    method: 'post',
    data:data
  })
}
// 项目公示查询
export function quotesSupplierQuotesSum(params) {
  return request({
    url: '/system/quotes/supplierBidResult' ,
    method: 'get',
    params:params
  })
}
// 查询保证金详情
export function marginSignupId(id) {
  return request({
    url: '/margin/signupId/'+id ,
    method: 'get',
  })
}
// 保证金确认
export function refundConfirm(data) {
  return request({
    url: '/margin/refund/confirm' ,
    method: 'post',
    data:data
  })
}
// 申诉问题添加
export function questionBidAnnounceQuestion(data) {
  return request({
    url: '/question/bidAnnounceQuestion' ,
    method: 'post',
    data:data
  })
}
// 询价 是否接受结算方式
export function sectionAcceptPaymentMethods(data) {
  return request({
    url: '/system/section/acceptPaymentMethods' ,
    method: 'post',
    data:data
  })
}
// 报名下载模版
export function authorizationDownLoad(data) {
  return request({
    url: '/web/authorization/template/downLoad',
    method: 'get',
    responseType: 'blob'  /* 一定要加这个 不然文件内容显示不了 */
  })
}
// 提交企业认证
export function submitAuthorization(data) {
  return request({
    url: '/web/authorization/authenticate' ,
    method: 'post',
    data:data
  })
}
// 校验当前用户是否需要企业认证
export function authorizationVerify() {
  return request({
    url: '/web/authorization/verify' ,
    method: 'get'
  })
}
// 当前用户企业认证信息
export function getAuthorization() {
  return request({
    url: '/web/authorization/getAuthorization' ,
    method: 'get'
  })
}
// 基础文件提交
export function quotationSupplierBaseFile(data) {
  return request({
    url: '/quotation/SupplierBaseFile',
    method: 'post',
    data: data
  })
}
// 报价说明提交
export function signuSubmitQuotesFile(data) {
  return request({
    url: '/quotation/signup/submitQuotesFile',
    method: 'post',
    data: data
  })
}

// 供应商提交报价
export function submitWinningQuotes(data) {
  return request({
    url: '/system/section/submitWinningQuotes' ,
    method: 'post',
    data:data
  })
}
export function triggerUpdateStatus(id) {
  return request({
    url: '/system/section/triggerUpdateStatus/'+id,
    method: 'get',
  })
}
// 根据tin查询企业信息
export function getAuthorizationByRaxCode() {
  return request({
    url: '/web/authorization/getAuthorizationByRaxCode',
    method: 'get',
  })
}
// 查询招标联系人
export function bpmUserList(params) {
  return request({
    url: '/bpm/bpmUser/list',
    method: 'get',
    params:params

  })
}
//查看 需要维护价格的标 数量
export function getToDetailQuoted() {
  return request({
    url: '/system/section/getToDetailQuoted',
    method: 'get',

  })
}
//印尼转非印尼供应商
export function changeEnterpriseCategoryNonIndonesian() {
  return request({
    url: '/web/authorization/changeEnterpriseCategoryNonIndonesian',
    method: 'get',

  })
}
//添加供货类型及品牌
export function supplierTypeApprove(data) {
  return request({
    url: '/quotation/supplierTypeApprove' ,
    method: 'post',
    data:data
  })
}

//修改供货类型及品牌
export function supplierTypeApprovePut(data) {
  return request({
    url: '/quotation/supplierTypeApprove' ,
    method: 'put',
    data:data
  })
}
//供货类型及品牌审批记录

export function supplierTypeApproveList(params) {
  return request({
    url: '/quotation/supplierTypeApprove/homeList' ,
    method: 'get',
    params:params
  })
}

//查询招标项目 发起供货类型审批的
export function getSectionReviewList(params) {
  return request({
    url: '/system/section/getSectionReviewList' ,
    method: 'get',
    params:params
  })
}

export function getByUser() {
  return request({
    url: '/quotation/declare/getByUser/0' ,
    method: 'get',
  })
}
